import globalApi from '@/request/globalApi/globalApi'

const END_POINT = '/api/register'

export const fetchRegisterSelectOfferRequest = token => globalApi.get(`${END_POINT}/select-offer/${token}`)

export const patchRegisterSelectOfferRequest = (token, offer, message) => globalApi.patch(`${END_POINT}/select-offer/${token}`, offer, { message })
